import React from "react";

const SvgBBiconsRozbalit = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <path
      d="M59.54 75.54A9.08 9.08 0 0053 91l40.26 40.74a9.06 9.06 0 0012.83.07L146.9 91.6a9.1 9.1 0 00-12.79-12.94l-34.27 33.88L66 78.23a9.16 9.16 0 00-6.46-2.69z"
      data-name="Obecn\xE9 ikony"
    />
  </svg>
);

export default SvgBBiconsRozbalit;
